
export type TcpConnectionStatus = "Ok" | "AuthorizationFailed" | "TcpVersionMismatch" | "InvalidNetworkTopology";
